<template>
    <div class="link-loading-shadow" :class="[{'link-loading-shadow-active':value}]">
        <link-loading/>
        <div v-if="!!$slots.default" class="link-loading-shadow-slot">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "link-loading-shadow",
        props: {
            value: {type: Boolean, default: false},
        },
        data() {
            return {}
        },
        methods: {},
    }
</script>

<style lang="scss">
    @include themeify {
        .link-loading-shadow {
            transition: all 0.3s linear;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            opacity: 0;
            pointer-events: none;
            z-index: 3;

            .link-loading {
                color: pl-var(color-primary);
                font-size: 36px;
            }

            .link-loading-shadow-slot {
                margin-top: 20px;
            }

            &.link-loading-shadow-active {
                opacity: 1;
                pointer-events: auto;
            }
        }
    }
</style>